import { useAuthStore } from '../store/auth.store';
import { USER_ROLES } from '../utils/constants';

export const usePermission = () => {
  const { user } = useAuthStore();

  const can = (action, resource) => {
    if (!user) { return false; }

    // Referral doctors only ever see the Referred Children screen and their dashboard
    if (user.role === USER_ROLES.DOCTOR && user.isReferralDoctor === true) {
      return resource === 'referral' || resource === 'dashboard';
    }

    const permissions = {
      admin: {
        manage: ['clinic', 'school', 'staff', 'doctor', 'event', 'user', 'dashboard', 'referral'],
        view: ['clinic', 'school', 'staff', 'doctor', 'event', 'child', 'registration', 'checkup', 'report', 'referral'],
      },
      school_staff: {
        manage: ['child', 'registration'],
        view: ['event', 'child', 'registration', 'dashboard', 'report'],
      },
      doctor: {
        manage: ['checkup', 'referral'],
        view: ['event', 'child', 'checkup', 'dashboard', 'report', 'referral'],
      },
    };

    const rolePerms = permissions[user.role];
    if (!rolePerms) { return false; }

    if (action === 'manage') {
      return rolePerms.manage?.includes(resource) || false;
    }
    if (action === 'view') {
      return rolePerms.view?.includes(resource) || rolePerms.manage?.includes(resource) || false;
    }
    return false;
  };

  return {
    can,
    isAdmin: user?.role === USER_ROLES.ADMIN,
    isSchoolStaff: user?.role === USER_ROLES.SCHOOL_STAFF,
    isDoctor: user?.role === USER_ROLES.DOCTOR,
    isReferralDoctor: user?.role === USER_ROLES.DOCTOR && user?.isReferralDoctor === true,
    role: user?.role,
  };
};
